export default {
    add: {
        index: {
            okTitle: 'Добавить',
            cancelTitle: 'Отмена',
            title: 'Добавление товара',
        },

        quantity: 'Количество',

        search: {
            description: 'Введите локальный код или штрихкод товара.',
            label: 'Код',
        },

        searchList: {
            text1: 'ЛК',
            text2: 'ШК',
            text3: 'Цена',
        },
    },

    list: {
        emptyText: 'Товары не найдены',
        emptyFilteredText: 'Товары не найдены',
        action: '[АКЦИЯ]',
        tooltip: 'Скопировать все локальные коды товаров',
        validate:
      'Количество не может быть меньше нуля | Количество собранных товаров не может превышать количество заказанных',
        tarePlaceholder: 'Укажите кол-во упакованных позиций',
    },

    productComment: {
        label1: 'Причина изменения:',
        label2: 'Комментарий:',
    },
};